// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { store } from '@/store'
import { fetchWithTimeout } from '@/common/shared'
import { ehrBaseUrl } from '@/settings'


export const getPatientId = async (mrn) => {
  const baseUrl = `${ehrBaseUrl}/patient_id`
  try {
    const fetchParams = {
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + store.getters.jwt,
      },
    }

    const url = `${baseUrl}?MRN=${mrn}`
    const response = await fetchWithTimeout(url, fetchParams)

    if (!response.ok) {
      console.log(`error: status=${response.status}`)
      return []
    }

    const results = await response.json()
    if (!results) { return [] }

    return results
  } catch (e) {
    if (e.name === 'AbortError') {
      console.log('timeout error')
    } else {
      console.log('ERROR:', e)
    }
  }
  return []
}
